export { default as PasarelaPago } from './Pasarela';
export { default as VistaOK } from './VistaOK';
export { default as VistaKO } from './VistaKO';
